import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Building2, ShoppingCart, Users, Package } from "lucide-react";

export default function SuperDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/platform/stats").then(({ data }) => setS(data)); }, []);
  const cards = [
    { icon: Building2, label: "Tenants", value: s?.total_tenants ?? "—", accent: "text-indigo-300" },
    { icon: Package, label: "Active tenants", value: s?.active_tenants ?? "—", accent: "text-emerald-300" },
    { icon: ShoppingCart, label: "Orders (all)", value: s?.total_orders ?? "—", accent: "text-orange-300" },
    { icon: Users, label: "Customers (all)", value: s?.total_customers ?? "—", accent: "text-fuchsia-300" },
  ];
  return (
    <div className="space-y-6">
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-100">Overview</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <Card key={c.label} className="bg-slate-900 border-slate-800 p-5">
            <div className="flex items-center justify-between">
              <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{c.label}</div>
              <c.icon className={`w-4 h-4 ${c.accent}`} />
            </div>
            <div className="mt-3 font-display text-2xl sm:text-3xl font-extrabold font-mono-nums text-white">{c.value}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
